import React, {useEffect, useState} from 'react';
import {
    Button,
    CardText,
    Col,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Spinner
} from "reactstrap";
import {Controller, useForm} from "react-hook-form";
import Select from "react-select";
import {countryOptions, documentTypes, statusOptions} from "../../../../../utility/helpers";
import classnames from "classnames";
import axios from "axios";
import toast from "react-hot-toast";
import { selectThemeColors } from '@utils'

const EditSigner = ({isOpen, handleClose, item}) => {

    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const defaultValues = {
        fullName: "",
        country: null,
        documentType: null,
        document: "",
        email: "",
        phone: "",
        company: ""
    };

    const {
        control,
        setError,
        handleSubmit,
        setValue,
        reset,
        formState: { errors }
    } = useForm({ defaultValues });

    useEffect(() => {
        if (item) {
            setValue('fullName', item.fullName);
            setValue('country', countryOptions.find(con => con.label === item.country));
            setValue('documentType', documentTypes.find(doc => doc.label === item.documentType));
            setValue('document', item.document);
            setValue('email', item.email);
            setValue('phone', item.phone);
        } else {
            reset();
        }
    }, [item])

    const getCompanies = async () => {
        const response =  await axios.get(`${process.env.REACT_APP_API_URL}/companies`)
        const companiesList = response?.data.map((item) => {
            return {
                value: item.id,
                label: item.name
            }
        });
        setCompanies(companiesList);
        setValue('company', companiesList.find(comp => comp.label === item.company));
    }

    useEffect(() => {
        if (item) {
            getCompanies()
        }

    }, [item]);


    const onSubmit = async (data) => {
        if (Object.values(data).every(field => field.length > 0 || field.label)) {
            try {
                setLoading(true);
                await axios.post(`${process.env.REACT_APP_API_URL}/signatories/${item.id}`, {
                    fullName: data.fullName,
                    country: data.country.label,
                    documentType: data.documentType.label,
                    document: data.document,
                    email: data.email,
                    phone: data.phone,
                    companyId: data.company.value
                });
                setLoading(false);
                toast.success('Firmante creado con exito!');
                setTimeout(() => window.location.reload(), 1000);
            } catch (e) {
                setLoading(false);
                toast.error(`Ha ocurrido un error: ${e.response.data.message || e.message}`);
            }
        } else {

            for (const key in data) {
                if (data[key] === null) {
                    setError(key, {
                        type: 'manual'
                    })
                }
                if (data[key] !== null && data[key].length === 0) {
                    setError(key, {
                        type: 'manual'
                    })
                }
            }
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={() => handleClose(false)} className='modal-dialog-centered modal-lg'>
            <ModalHeader className='bg-transparent' toggle={() => handleClose(false)}></ModalHeader>
            <ModalBody className='px-sm-5 mx-50 pb-5'>
                <div className='text-center mb-2'>
                    <h1 className='mb-1'>Editar firmante</h1>
                    <p>Editar firmante con los datos correspondientes.</p>
                </div>


                {loading ? <Row>
                    <div className='col-12 px-2 py-4 text-center'>
                        <Spinner size='lg'/>
                        <CardText className={'py-1 fs-5'}>Creando sociedad...</CardText>
                    </div>
                </Row> : <Row tag='form' className='gy-1 pt-75' onSubmit={handleSubmit(onSubmit)}>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='fullName'>
                            Nombre completo*
                        </Label>
                        <Controller
                            control={control}
                            name='fullName'
                            render={({ field }) => {
                                return (
                                    <Input
                                        {...field}
                                        id='fullName'
                                        placeholder='John Cardenas'
                                        value={field.value}
                                        invalid={errors.fullName && true}
                                    />
                                )
                            }}
                        />
                        {errors.fullName && <FormFeedback>Por favor ingrese un nombre completo valido</FormFeedback>}
                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='country'>
                            Pais*
                        </Label>

                        <Controller
                            name='country'
                            control={control}
                            render={({ field }) => (
                                // <Input id='country' placeholder='Australia' invalid={errors.country && true} {...field} />
                                <Select
                                    isClearable={false}
                                    classNamePrefix='select'
                                    options={countryOptions}
                                    theme={selectThemeColors}
                                    className={classnames('react-select', { 'is-invalid': errors.country })}
                                    {...field}
                                />
                            )}
                        />
                        {errors.country && <FormFeedback>Por favor seleccione un pais valido</FormFeedback>}
                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='documentType'>
                            Tipo de documento*
                        </Label>

                        <Controller
                            name='documentType'
                            control={control}
                            render={({ field }) => (
                                // <Input id='country' placeholder='Australia' invalid={errors.country && true} {...field} />
                                <Select
                                    isClearable={false}
                                    classNamePrefix='select'
                                    options={documentTypes}
                                    theme={selectThemeColors}
                                    className={classnames('react-select', { 'is-invalid': errors.documentType })}
                                    {...field}
                                />
                            )}
                        />
                        {errors.documentType && <FormFeedback>Por favor seleccione un tipo de documento valido</FormFeedback>}

                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='document'>
                            Id de documento*
                        </Label>
                        <Controller
                            id='document'
                            name='document'
                            control={control}
                            render={({field}) => <Input placeholder='Numero de documento'
                                                        invalid={errors.document && true} {...field} />}
                        />
                        {errors.document && <FormFeedback>El numero de documento es obligatorio</FormFeedback>}
                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='email'>
                            Email*
                        </Label>
                        <Controller
                            name='email'
                            control={control}
                            render={({field}) => <Input
                                type='email'
                                id='email'
                                placeholder='john.doe@example.com'
                                invalid={errors.email && true} {...field} />}
                        />
                        {errors.email && <FormFeedback>El email es obligatorio</FormFeedback>}
                    </Col>
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='phone'>
                            Celular*
                        </Label>
                        <Controller
                            id='phone'
                            name='phone'
                            control={control}
                            render={({field}) => (
                                <Input placeholder='+503 70805520' type='number'
                                       invalid={errors.phone && true} {...field} />
                            )}
                        />
                        {errors.phone && <FormFeedback>El numero teléfono es obligatorio</FormFeedback>}
                    </Col>
                    {/*<Col md={6} xs={12}>
                        <Label className='form-label' for='status'>
                            Estado*
                        </Label>
                        <Controller
                            name='status'
                            control={control}
                            render={({ field }) => (
                                // <Input id='country' placeholder='Australia' invalid={errors.country && true} {...field} />
                                <Select
                                    isClearable={false}
                                    classNamePrefix='select'
                                    options={statusOptions}
                                    theme={selectThemeColors}
                                    className={classnames('react-select', { 'is-invalid': data !== null && data.status === null })}
                                    {...field}
                                />
                            )}
                        />
                    </Col>*/}
                    <Col md={6} xs={12}>
                        <Label className='form-label' for='company'>
                            Sociedad*
                        </Label>
                        <Controller
                            name='company'
                            control={control}
                            render={({ field }) => (
                                // <Input id='country' placeholder='Australia' invalid={errors.country && true} {...field} />
                                <Select
                                    isClearable={false}
                                    classNamePrefix='select'
                                    options={companies}
                                    theme={selectThemeColors}
                                    className={classnames('react-select', { 'is-invalid': errors.company })}
                                    {...field}
                                />
                            )}
                        />
                        {errors.company && <FormFeedback>Por favor seleccione una compañia valida</FormFeedback>}
                    </Col>

                    <Col md={12} xs={12}>
                        <small className={'text-secondary'}>
                            Campos obligatorios (*)
                        </small>
                    </Col>

                    <Col xs={12} className='text-center mt-2 pt-50'>
                        <Button type='submit' className='me-1' color='primary'>
                            Guardar
                        </Button>
                        <Button type='reset' color='secondary' outline onClick={() => handleClose(false)}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>}

            </ModalBody>
        </Modal>
    );
};

export default EditSigner;
